export default "__VITE_ASSET__BkEU6U$k__"